var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 28,
    viewBox: "0 0 11 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28716 0.603516C7.63044 0.603516 7.00061 0.864399 6.53623 1.32877C6.07186 1.79315 5.81097 2.42298 5.81097 3.07971C5.81097 3.73643 6.07186 4.36626 6.53623 4.83064C7.00061 5.29501 7.63044 5.5559 8.28716 5.5559C8.94389 5.5559 9.57372 5.29501 10.0381 4.83064C10.5025 4.36626 10.7634 3.73643 10.7634 3.07971C10.7634 2.42298 10.5025 1.79315 10.0381 1.32877C9.57372 0.864399 8.94389 0.603516 8.28716 0.603516ZM7.69288 8.4778C5.72843 8.64288 0.363353 12.9184 0.363353 12.9184C0.0331947 13.1661 0.132243 13.1495 0.39637 13.6118C0.660497 14.0575 0.627481 14.0905 0.941132 13.8759C1.27129 13.6613 1.81605 13.3146 2.72399 12.7534C6.22367 10.5083 3.28526 15.6918 1.78304 24.4245C1.18875 28.7495 5.08462 26.521 6.09161 25.8607C7.08208 25.2168 9.73986 23.3845 10.004 23.2029C10.3672 22.9553 10.103 22.7572 9.8224 22.3445C9.62431 22.0638 9.42621 22.2619 9.42621 22.2619C8.35319 22.9718 6.38875 24.4575 6.12462 23.5165C5.81097 22.5756 7.82494 16.121 8.93097 11.6803C9.11256 10.6238 9.6078 8.31272 7.69288 8.4778Z",
    fill: "#DB3251"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicator);
export default __webpack_public_path__ + "static/media/indicator.6b55508b2a3f339fda91a666be009519.svg";
export { ForwardRef as ReactComponent };